// /var/www/afra/192.testproject.work/maracar8/0.8.2/myapp/src/pages/Member.js

import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from '../components/Header';
import MemberTable from '../components/MemberTable';
import MemberForm from '../components/MemberForm';
import MemberSpecific from '../components/MemberSpecific';
import { getSelectedLanguage } from '../api/api';
import { languageManager } from '../utils/loadLanguage';
import { fetchMemberData } from '../utils/HandlersMember'; // นำเข้าฟังก์ชันจาก HandlersMember
import '../css/Member.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

const Member = () => {
  const [memberData, setMemberData] = useState([]);
  const [currentMember, setCurrentMember] = useState(null);
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [formMode, setFormMode] = useState('add');
  const [showSpecific, setShowSpecific] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const navigate = useNavigate();
  const loggedInUserID = localStorage.getItem('user_ID');
  const [searchQuery, setSearchQuery] = useState('');
  const [translations, setTranslations] = useState({});
  const [isLoadingMembers, setIsLoadingMembers] = useState(false);

  useEffect(() => {
    async function loadLang() {
      const lang = getSelectedLanguage();
      await languageManager.loadLanguage(lang);
      setTranslations(languageManager.translations.menu || {});
    }
    loadLang();
  }, []);

  const t = translations;

  const handleCancelEdit = () => {
    setIsFormVisible(false);
    setShowSpecific(false);
    setSelectedUserId(null);
  };

  const handleEditMember = (member) => {
    //console.log('Edit Member:', member);
    setCurrentMember(member);
    setFormMode('edit');
    setIsFormVisible(true);
    setShowSpecific(false);
  };

  const handleAddMember = () => {
    setCurrentMember(null);
    setFormMode('add');
    setIsFormVisible(true);
    setShowSpecific(false);
  };

  const handleViewSpecific = (userId) => {
    setSelectedUserId(userId);
    setShowSpecific(true);
    setIsFormVisible(false);
  };

  const fetchMembers = useCallback(async () => {
    setIsLoadingMembers(true);
    const token = localStorage.getItem('token');
    if (!loggedInUserID || !token) {
      console.warn("User ID or Token is missing, skipping fetchMembers.");
      if (!token) navigate('/');
      setIsLoadingMembers(false);
      return;
    }
    try {
      const data = await fetchMemberData(loggedInUserID, token); // ใช้ฟังก์ชันจาก HandlersMember
      setMemberData(data);
    } catch (error) {
      console.error("Error loading member data:", error);
      setMemberData([]);
    } finally {
      setIsLoadingMembers(false);
    }
  }, [loggedInUserID, navigate]);

  useEffect(() => {
    if (!localStorage.getItem('token')) {
      navigate('/');
      return;
    }
    if (!showSpecific && !isFormVisible) {
      fetchMembers();
    }
  }, [navigate, fetchMembers, showSpecific, isFormVisible]);

  const handleTableRefresh = useCallback(() => {
    if (!showSpecific && !isFormVisible) {
      fetchMembers();
    }
  }, [fetchMembers, showSpecific, isFormVisible]);

  return (
    <div className="dashboard">
      <Sidebar />
      <div className="dashboard-main">
        <Header
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          onBack={isFormVisible || showSpecific ? handleCancelEdit : undefined}
          refreshData={handleTableRefresh}
        />
        <div className="p-datatable-details">
          <div className="row">
            <div className="col-12 col-sm-12">
              <div className="member-table-container">
                {showSpecific ? (
                  <MemberSpecific
                    userId={selectedUserId}
                    translations={translations}
                    onCancel={handleCancelEdit}
                  />
                ) : isFormVisible ? (
                  <MemberForm
                    memberData={currentMember}
                    mode={formMode}
                    onCancel={handleCancelEdit}
                    setIsFormVisible={setIsFormVisible}
                    onTableRefresh={handleTableRefresh}
                  />
                ) : (
                  <>
                    <div className="d-grid gap-2 d-md-flex justify-content-md-end mb-3">
                      <button onClick={handleAddMember} className="btn btn-primary btn-sm">
                        <FontAwesomeIcon icon={faPlus} /> {t.addMember || "Add Member"}
                      </button>
                    </div>
                    {isLoadingMembers ? (
                      <div className="text-center p-5">
                        <div className="spinner-border text-primary" role="status">
                          <span className="visually-hidden">{t.loading || 'Loading...'}</span>
                        </div>
                      </div>
                    ) : (
                      <MemberTable
                        memberData={memberData}
                        onEditMember={handleEditMember}
                        token={localStorage.getItem('token')}
                        onViewSpecific={handleViewSpecific}
                        loggedInUserID={loggedInUserID}
                        navigate={navigate}
                      />
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Member;